import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint, data = null) => apiCall("delete", endpoint, data);

export const getCategoryListApi = async (params) => {
    try {
        return await get("category", params);
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};


export const submitCategoryApi = async (body) => {
    try {
        return await post("category", body);
    } catch (err) {
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};


export const updateCategoryListApi = async (id, body) => {
    try {
        return await put(`category/${id}`, body);
    } catch (err) {
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

export const bulkDeleteCategoryApi = async (payload) => {
    try {
        const data = Array.isArray(payload) ? { id: payload } : payload;
        return await del("category/bulk_delete", data);
    } catch (err) {
        console.error("Error fetching category:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

export const deleteCategoryListApi = async (id) => {
    try {
        return await del(`category/delete/${id}`);
    } catch (err) {
        console.error("Error fetching category:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};
export const getCategoryByIdApi = async (id) => {
    try {
        return await get(`category/edit/${id}`);
    } catch (err) {
        console.error("Error fetching category:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};